import { axiosInstance as axios } from 'helpers/axiosInstance';
import logger from 'helpers/logger';
import { queryCmsContent } from './_api';
import { newsCardMapper, newsWithTagsCardMapper } from 'helpers/mappers';
//CMS is not exposed to the website, therefore we fetch the news via a Next.JS API
export const getNewsFromApi = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
	filter = '[]',
): Promise<News.NewsArticle[]> => {
	return axios({
		url: `/api/news`,
		method: 'POST',
		headers: {},
		data: {
			rootId,
			limit,
			offset,
			preview,
			previewData,
			filter,
		},
	})
		.then((res) => {
			const articles: News.NewsArticle[] = res.data?.newsArticles;
			return articles;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			logger.error(`getNewsFromApi() \nNews retrieval from API failed \n${message}`);
			throw message;
		});
};

export const getNewsFromCms = async (
	rootId: number,
	limit: number,
	offset: number,
	preview: boolean,
	previewData: Content.PreviewData,
	filter = '[]',
): Promise<(News.NewsArticle | News.NewsArticleWithTags)[]> => {
	const graphQLquery = `{
		pageSearch(
			documentType:["newsPage", "newsPageWithTags"] 
			rootIds:[${rootId}] 
			limit:${limit} 
			offset:${offset}
			filter: ${filter}
			)
			{
				pages {
					documentType
					name
					url
					id
					properties
					sortOrder
				}
			}
		}`;

	const profiler = logger.startTimer();
	try {
		const results = await queryCmsContent({
			query: graphQLquery,
			preview,
			previewData,
			method: 'POST',
		});

		const newsResults = results.pageSearch?.pages.map((page) =>
			page.documentType === 'newsPage' ? newsCardMapper(page) : newsWithTagsCardMapper(page),
		);

		if (newsResults) {
			const newsPages = newsResults.filter((page) => page.documentType === 'newsPage');
			newsPages.sort((a, b) => b.date?.localeCompare(a.date));

			const newsPagesWithTags = newsResults.filter((page) => page.documentType === 'newsPageWithTags');
			newsPagesWithTags.sort((a, b) => a.sortOrder - b.sortOrder);

			const sortedResults = [...newsPages, ...newsPagesWithTags];

			return sortedResults;
		}
	} finally {
		profiler.done({ message: 'getNews', level: 'debug' });
	}
};
